import React, { useEffect } from "react";
import { connect } from "react-redux";
import SelectV2 from "../../view/SelectV2";
import { debug } from "../../utils";
import * as modalDataService from "./modalDataService";

const criticalityOptions = [
    { value: "High", label: "High", tone: "high" },
    { value: "Medium", label: "Medium", tone: "medium" },
    { value: "Low", label: "Low", tone: "low" }
];

function CriticalityOptionLabel({ label, tone }) {
    return (
        <span className="modal-v2-criticality-option">
            <span className={`modal-v2-criticality-dot is-${tone}`} aria-hidden="true" />
            <span>{label}</span>
        </span>
    );
}

function CriticalityField({ criticality, disabled }) {

    useEffect(() => {
        !criticality && onChange(criticalityOptions[0].value);
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [])

    const onChange = (value) => modalDataService.changeCriticality(value);

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="criticality">Criticality Level <span className="modal-v2-required-mark">*</span></label>
                <SelectV2
                    inputId="criticality"
                    className="modal-v2-criticality-select"
                    value={criticality || criticalityOptions[0].value}
                    onChange={onChange}
                    options={criticalityOptions}
                    isDisabled={disabled}
                    formatOptionLabel={(option) => (
                        <CriticalityOptionLabel label={option.label} tone={option.tone} />
                    )}
                />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("GroupField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        criticality: addDeviceModal.criticality,
    };
}

export default connect(mapStateToProps)(CriticalityField);
